import { Button, message, notification, Space } from 'antd'
import { useEffect } from 'react'
import { errorResponse } from './errorResponse'
import { signOut } from 'firebase/auth'
import { useAuth, useFunctions } from 'reactfire'
import { useTranslation } from 'react-i18next'
import { api } from './api'

let acceptWasCalled = false
export default function useAcceptTaxAdvisorInvitation(
  searchParams,
  setSearchParams,
  successCallback
) {
  const auth = useAuth()
  const functions = useFunctions()
  const { t } = useTranslation()

  return useEffect(() => {
    if (acceptWasCalled) return
    acceptWasCalled = true
    // noinspection JSIgnoredPromiseFromCall
    acceptTaxAdvisorInvitationFromQueryString(
      searchParams,
      setSearchParams,
      successCallback,
      auth,
      functions,
      t
    )
    // Only execute once on mount
    // eslint-disable-next-line
  }, [])
}

async function acceptTaxAdvisorInvitationFromQueryString(
  searchParams,
  setSearchParams,
  successCallback,
  auth,
  functions,
  t
) {
  const clearInvitationParam = () => {
    searchParams.delete('tax_advisor_invitation')
    searchParams.delete('mode')
    searchParams.delete('email')
    setSearchParams(searchParams)
  }

  async function acceptTaxAdvisorInvitationAction(
    taxAdvisorInvitation,
    forceAccept
  ) {
    message.loading({
      content: t('frontend:invitations.accepting'),
      duration: 0,
      key: 'tax_advisor_invitation',
    })

    const data = await api(functions, 'taxadvisors/accept_manager_invitation', {
      taxAdvisorInvitation,
      forceAccept,
    })

    const { taxAdvisorUid } = data

    message.destroy('tax_advisor_invitation')
    message.success(t('frontend:invitations.accepted'))
    clearInvitationParam()
    successCallback(taxAdvisorUid)
  }

  if (searchParams.has('tax_advisor_invitation')) {
    const taxAdvisorInvitation = searchParams.get('tax_advisor_invitation')
    try {
      await acceptTaxAdvisorInvitationAction(taxAdvisorInvitation, false)
    } catch (error) {
      message.destroy('tax_advisor_invitation')
      if (error.code) {
        switch (error.code) {
          case 'functions/not-found':
          case 'functions/invalid-argument':
            message.error(t('frontend:invitations.invalid'))
            clearInvitationParam()
            break
          case 'functions/already-exists':
            message.warning({
              content: t('frontend:invitations.alreadyAccepted'),
              key: 'tax_advisor_invitation',
            })
            clearInvitationParam()
            break
          case 'functions/permission-denied':
            if (error.message === 'EMAIL_MISMATCH') {
              const invitationEmail = error.details?.email
              notification.error({
                key: 'tax-advisor-invitation-notification',
                message: t('frontend:invitations.otherAccountTitle'),
                description: t(
                  'frontend:invitations.emailMismatchDescriptionFormal',
                  {
                    invitationEmail,
                    currentEmail: auth?.currentUser?.email,
                  }
                ),
                duration: 0,
                btn: (
                  <Space direction="vertical" style={{ width: '100%' }}>
                    <Button
                      block
                      onClick={async () => {
                        notification.destroy(
                          'tax-advisor-invitation-notification'
                        )
                        await acceptTaxAdvisorInvitationAction(
                          taxAdvisorInvitation,
                          true
                        )
                      }}
                      style={{ wordWrap: 'break-word' }}
                    >
                      {t('frontend:invitations.linkInvitationToAccount')}
                    </Button>
                    <Button
                      block
                      danger
                      onClick={() => {
                        signOut(auth)
                        window.location.reload()
                      }}
                    >
                      {t('frontend:invitations.logout')}
                    </Button>
                  </Space>
                ),
              })
            } else errorResponse(error)
            break
          default:
            errorResponse(error)
            break
        }
      } else {
        errorResponse(error)
      }
    }
  }
}
